import { render } from "./DiscountSettings.vue?vue&type=template&id=987490b6&scoped=true"
import script from "./DiscountSettings.vue?vue&type=script&lang=js"
export * from "./DiscountSettings.vue?vue&type=script&lang=js"

import "./DiscountSettings.vue?vue&type=style&index=0&id=987490b6&scoped=true&lang=css"
import "./DiscountSettings.vue?vue&type=style&index=1&id=987490b6&scoped=true&lang=css"
import "@vueform/multiselect/themes/default.css?vue&type=style&index=2&lang=css"

import exportComponent from "D:\\xampp7\\htdocs\\24x7pos\\client\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-987490b6"]])

export default __exports__